(ns teamoesterreich.user-mode.location.location-view
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.home :refer [home]]

    [reagent.core :as r]
    [teamoesterreich.config :as config]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.util.log :as log]))



(defn get-it []
  (log/out "init location view")
  (let [!st (r/atom {:location-form {}})]
    (fn []
      (let [!actual-location (r/cursor store/app-state [:state :selected-location])
            !location (r/cursor store/app-state [:locations @!actual-location])
            lat (and (get-in @!location [:coordinates]) (.-_lat ^js (get-in @!location [:coordinates])))
            lng (and (get-in @!location [:coordinates]) (.-_long ^js (get-in @!location [:coordinates])))
            ]
        (log/out "redraw location view" @!actual-location @!location)


        [mui/grid
         {:container  true
          :direction  "row"
          :justify    "center"
          :alignItems "center"
          :spacing    4
          }

         [mui/grid
          {:item true
           :md   6                                          ;medium: 960px
           :xs   12                                         ;extra-small: 0px
           }
          [mui/card {:class "" :style {:textAlign "left" :padding "25px" :marginTop "20px"}}
           [mui/card-media
            {:component "img"

             :image     (or (when-not (= "" (:location-picture-path-fst @!location)) (:location-picture-path-fst @!location))
                            (and lat lng
                                 (str "https://maps.googleapis.com/maps/api/staticmap?"
                                      "center=" lat "," lng "&zoom=12&size=1000x200&"
                                      "markers=color:red|" lat "," lng
                                      "&key=" config/GOOGLE_MAPS_API "&"
                                      ))
                            "/custom/img/home.png")
             :height    "200"
             :title     (str (get-in @!location [:name]))
             :alt       (str (get-in @!location [:name]))
             }]
           [mui/card-actions
            [mui/button {:variant   "outlined" :startIcon (r/as-element [edit])
                         :component "span"
                         :onClick   (fn []
                                      (if (= (:site @store/app-state) :warning-locationView)
                                        (a/set-page :warning-locationForm)
                                        (a/set-page :prevent-locationForm)))
                         }
             "Bearbeiten"]
            ]


           [mui/card-content
            [mui/grid
             {:container  true
              :direction  "column"
              :justify    "space-between"
              :alignItems "flex-start"
              :spacing    1
              }
             [mui/grid
              {:container false :item true
               :xs        12                                ;extra-small: 0px
               }
              [:h1 [home] " Standorteinstellungen"]
              ]

             [mui/grid
              {:container  true
               :direction  "row"
               :justify    "flex-start"
               :alignItems "flex-start"
               :spacing    1
               :style      #js {:margin "0"}
               }
              [mui/grid
               {:container false :item true
                :md        12                               ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/text-field {
                                :fullWidth true
                                :value     (or (:name @!location) "")
                                :disabled  true
                                :label     "Standort Name"}]

               ]


              ;; address
              [mui/grid
               {:container false :item true
                :md        12                               ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/text-field {
                                :fullWidth true
                                :value     (or (:address @!location) "")
                                :disabled  true
                                :label     "Adresse"}]

               ]
              ]]]

           ]]]
        ))))




